<template>
  <div class="page-apply">
    <div class="content-wrapper">
      <div class="breadcrumb-wrapper">
        <h-breadcrumb separator=">">
          <h-breadcrumb-item href="/serviceProductAll"
            >组件集市</h-breadcrumb-item
          >
          <h-breadcrumb-item>支付结果</h-breadcrumb-item>
        </h-breadcrumb>
      </div>
      <div class="form-wrapper">
        <img
          class="content-img"
          src="~@/assets/service/success_pic.png"
          alt=""
        />
        <div class="content-title">订单支付成功！</div>
        <div class="desc">订单编号：{{ order_id }}</div>
        <div class="go-btn" @click="goOrder">查看订单</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "orderPaySuccess",
  data() {
    const _this = this;

    return {
      order_id: this.$route.query.order_id
    };
  },
  computed: {},
  created() {},
  methods: {
    goOrder(){
       window.location.href = "/cloud-console/trade/myOrder";
    }
    
  }
};
</script>
<style lang="scss" scoped>
.mr-30 {
  margin-right: 30px;
}
.page-apply {
  padding-bottom: 70px;
}
.content-wrapper {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0 9px 0;
}
.form-wrapper {
  width: 1200px;
  height: 432px;
  background: #ffffff;
  border-radius: 2px;
  margin: 0 auto;
  padding-top: 107px;
  margin-top: 20px;
  text-align: center;
  .desc {
    height: 18px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #646566;
    text-align: center;
    line-height: 18px;
    font-weight: 400;
    margin-top: 12px;
  }
  .go-btn {
    width: 116px;
    height: 32px;
    background: #3b6bfa;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.06);
    border-radius: 2px;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 32px;
    font-weight: 400;
    margin: 32px auto;
    cursor: pointer;
  }
}
.content-img {
  width: 91px;
  height: 112px;
  margin: 0 auto;
  display: block;
}
.content-title {
  height: 22px;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #323233;
  text-align: center;
  font-weight: 600;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/orderPaySuccess.vue